/**
 * Date range presets for dashboard (aligned with mobile).
 */

const fmt = (d) => d.toISOString().split('T')[0];

export const PRESETS = [
  'today',
  'yesterday',
  'last7Days',
  'thisMonth',
  'lastMonth',
  'thisYear',
  'lastYear',
  'lifetime',
  'custom',
];

export const PRESET_LABELS = {
  today: 'Today',
  yesterday: 'Yesterday',
  last7Days: 'Last 7 days',
  thisMonth: 'This month',
  lastMonth: 'Last month',
  thisYear: 'This year',
  lastYear: 'Last year',
  lifetime: 'Lifetime',
  custom: 'Custom',
};

/**
 * Returns { startDate, endDate } in YYYY-MM-DD for the given preset.
 * For 'custom' returns null.
 */
export function getRangeForPreset(preset) {
  const now = new Date();
  switch (preset) {
    case 'today':
      return { startDate: fmt(now), endDate: fmt(now) };
    case 'yesterday': {
      const y = new Date(now);
      y.setDate(y.getDate() - 1);
      return { startDate: fmt(y), endDate: fmt(y) };
    }
    case 'last7Days': {
      const start = new Date(now);
      start.setDate(start.getDate() - 6);
      return { startDate: fmt(start), endDate: fmt(now) };
    }
    case 'thisMonth': {
      const start = new Date(now.getFullYear(), now.getMonth(), 1);
      return { startDate: fmt(start), endDate: fmt(now) };
    }
    case 'lastMonth': {
      const firstThisMonth = new Date(now.getFullYear(), now.getMonth(), 1);
      const lastMonthEnd = new Date(firstThisMonth);
      lastMonthEnd.setDate(0);
      const lastMonthStart = new Date(lastMonthEnd.getFullYear(), lastMonthEnd.getMonth(), 1);
      return { startDate: fmt(lastMonthStart), endDate: fmt(lastMonthEnd) };
    }
    case 'thisYear': {
      const start = new Date(now.getFullYear(), 0, 1);
      return { startDate: fmt(start), endDate: fmt(now) };
    }
    case 'lastYear': {
      const start = new Date(now.getFullYear() - 1, 0, 1);
      const end = new Date(now.getFullYear() - 1, 11, 31);
      return { startDate: fmt(start), endDate: fmt(end) };
    }
    case 'lifetime': {
      const start = new Date(now.getFullYear() - 10, 0, 1);
      return { startDate: fmt(start), endDate: fmt(now) };
    }
    case 'custom':
    default:
      return null;
  }
}

/**
 * Which preset (if any) matches the given startDate and endDate.
 */
export function getPresetForRange(startDate, endDate) {
  if (!startDate || !endDate) return null;
  for (const preset of PRESETS) {
    if (preset === 'custom') continue;
    const range = getRangeForPreset(preset);
    if (range && range.startDate === startDate && range.endDate === endDate) return preset;
  }
  return 'custom';
}
